import * as React from 'react';

// SVG plano (no createIcon) para conservar el `fill="none"` del root: las formas
// con solo `stroke` se rellenarían de currentColor con createIcon.
type IconProps = React.SVGProps<SVGSVGElement>;

export function PedidosIcon(props: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 34 34'
      fill='none'
      width={24}
      height={24}
      {...props}>
      <rect x='14' y='10' width='17' height='18' rx='3' fill='#FFB800' />
      <path
        d='M14 23H31V25C31 26.7 29.7 28 28 28H17C15.3 28 14 26.7 14 25V23Z'
        fill='#FFD25C'
      />
      <rect x='21' y='10' width='3' height='18' fill='white' />
      <path d='M14 17H31' stroke='white' strokeWidth='2' />
      <rect x='3' y='6' width='16' height='23' rx='3' fill='white' />
      <rect
        x='3'
        y='6'
        width='16'
        height='23'
        rx='3'
        stroke='#0E3663'
        strokeWidth='1.2'
      />
      <rect x='7' y='3' width='8' height='5' rx='1.5' fill='#3885FE' />
      <rect x='9' y='4.5' width='4' height='2' rx='0.8' fill='white' />
      <path
        d='M7 13H15M7 17H13M7 21H14'
        stroke='#0E3663'
        strokeWidth='1.8'
        strokeLinecap='round'
      />
      <circle cx='18' cy='24' r='5' fill='#5CC9BA' />
      <circle cx='18' cy='24' r='3.6' fill='white' />
      <path
        d='M16 24L17.5 25.5L20.5 22.5'
        stroke='#0E3663'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
